// Plant mutations that can occur when planting
// Each mutation has a chance to appear and provides a damage multiplier

export default [
  {
    name: 'Normal',
    chance: 0.947, // 70% chance
    multiplier: 1.0,
  },
  {
    name: 'Gold',
    chance: 0.0445, // 4.45% chance
    multiplier: 2,
    color: '#FFD700', // gold
  },
  // {
  //     name: 'Rainbow',
  //     chance: 0.08, // 8% chance
  //     multiplier: 2.0,
  //     color: '#FF1493', // deep pink
  // },
  // {
  //     name: 'Galactic',
  //     chance: 0.05, // 5% chance
  //     multiplier: 3.0,
  //     color: '#9C27B0', // purple
  // },
  {
    name: 'Diamond',
    chance: 0.0045, // .45% chance
    multiplier: 3.0,
    color: '#00E5FF', // cyan
  },
  {
    name: 'Ruby',
    chance: 0.003, // 0.3% chance
    multiplier: 4.0,
    color: '#FF4500', // orange red
  },
  {
    name: 'Neon',
    chance: 0.001, // 0.1% chance
    multiplier: 5.0,
    color: '#50C878', // green
  },
]
